export enum INSTANCE_UI {
    /**
     * @value No favorites
     * @description Message displayed when a directory has no entries
     */
    FAVORITES_NO_ENTRIES = 'FRONT.FAVORITES.NO_ENTRIES',
}

export enum INSTANCE_PICKER {
    /**
     * @value Select a site
     * @description Trigger button, to show the site list picker.
     */
    SELECT_A_SITE = 'COMMUNITY_MOVE.SELECT',
}
